<script setup>
import { closest, edgeFromDtRange, ensureRef, formatDay, formatDayMin, post } from '@/common/util'
import { useEntityStructureStore, useMetaStore } from '@/stores'
import dayjs from 'dayjs'
import _ from 'lodash-es'
import { ref } from 'vue'
import { onMounted, reactive, useTemplateRef } from 'vue'
import { useI18n } from 'vue-i18n'
const props=defineProps(['ispop','mname','mid','logcate','targetid','hideclose','fixmem','showtitle']),emit=defineEmits(['closeLog'])
,ess=useEntityStructureStore(),metaStore=useMetaStore(),i18n=useI18n()
,meta=reactive({cols:[{nm:'cdt'},{nm:'logcate'},{nm:'logtype'},{nm:'logstatus'},{nm:'etc'}],tblheight:'100%'
  ,searchtypes:[{tkey:'all',val:''},{tkey:'workers',val:'executornm'},{tkey:'logtype',val:'logtype'},{tkey:'logstatus',val:'logstatus'}]
  ,loglims:[{lbl:i18n.t('unlimited'),val:'unlimited'},{lbl:1+' '+i18n.t('months'),val:'1m'},{lbl:6+' '+i18n.t('months'),val:'6m'}
    ,{lbl:1+' '+i18n.t('years'),val:'1y'},{lbl:3+' '+i18n.t('years'),val:'3y'},{lbl:5+' '+i18n.t('years'),val:'5y'},{lbl:10+' '+i18n.t('years'),val:'10y'}]
  ,search:{dtrange:[new Date,new Date],type:''},rows:[],page:1,size:20,isasc:false,sortcol:'cdt'})
,tbl=ref(null)
,search=async()=>{
  meta.isloading=true
  const pms={where:{},dtcol:'cdt',...edgeFromDtRange(meta.search.dtrange),page:meta.page,size:meta.size,isasc:meta.isasc,sortcol:meta.sortcol}
  if(props.logcate)pms.where.logcate_eq_=props.logcate
  if(props.targetid)pms.where.targetid_eq_=props.targetid
  if(meta.search.val){
    if(!meta.search.type){
      pms.where.executornm_or_=meta.search.val
      pms.where.logtype_or_=meta.search.val
      pms.where.logstatus_or_=meta.search.val
    }else pms.where[meta.search.type]=meta.search.val
  }
  const res=await post('rest/authed/admin/searchlog',pms)
  meta.data=res.data
  // meta.data.rows.forEach(row=>meta.data.rows.push(row))
  meta.isloading=false
  if(meta.ispop){
    let parentel=closest(meta.admlog.$el,'.v-card-text')
    if(!parentel)parentel=closest(meta.admlog.$el,'.v-overlay')
    meta.tblheight=parentel.clientHeight-500
  }else meta.tblheight=window.innerHeight-440
},pop=type=>{
  meta.poptype=null
  if(_.isEmpty(type)||type.toString().includes('Event'))return metaStore.pop({ison:false})
  metaStore.pop({ison:true,callback:()=>meta.poptype=type})
},sort=col=>{
  if(!meta.data||meta.data.rows.length==0)return
  if(meta.sortcol!=col)meta.sortcol=col
  else meta.isasc=!meta.isasc
  search()
},logLim=()=>{
  meta.onoverlay=false
  meta.onlimmod=true
  post('rest/authed/admin/resetconfs',[{wkey:'loglimit',sval:meta.sellim}],res=>{
    meta.onlimmod=false
    metaStore.toast(i18n.t('thesaveiscomplete')+' : '+res.data)
  })
}
meta.ispop=props.ispop||props.ispop===''||props.ispop==='true'||props.ispop===true
meta.fixmem=props.ispop||props.ispop===''||props.ispop==='true'||props.ispop===true
if(meta.ispop){
  meta.showtitle=props.showtitle||props.showtitle===''||props.showtitle==='true'||props.showtitle===true
}else meta.showtitle=true
meta.admlog=useTemplateRef('admlog')
if(!_.isEmpty(props.mname))meta.search.val=props.mname
ess.ensureItem('sitelog',ms=>{
  meta.struct=ms
  meta.cols.forEach(col=>{
    col.tkey=ms[col.nm].tkey
    col.type=ms[col.nm].type
  })
  post('rest/authed/member/confs',{wkey:'loglimit'},res=>{
    meta.sellim=res.data&&res.data.length>0?res.data[0].sval:'unlimited'
    search()
  })
})
if(meta.fixmem)meta.search.type='executornm'
onMounted(()=>{
  if(meta.ispop){
    meta.tblheight=meta.admlog.$el.clientHeight*.6
  }
})
</script>
<template>
  <v-card flat class="admlog" width="100%" height="100%" ref="admlog" min-width="780">
    <v-card-title>
      <v-row>
        <v-col v-if="meta.showtitle">{{ $t('viewlogs') }}</v-col>
        <v-col :cols="meta.showtitle?6:12" class="text-end">
          <v-btn v-if="!meta.ispop" :text="$t('set_log_lim')" :loading="meta.onlimmod" @click="pop('set_log_lim')"/>
          <v-btn v-if="meta.ispop&&!props.hideclose" density="compact" icon="mdi-close" @click="emit('closeLog')"/>
        </v-col>
      </v-row>
    </v-card-title>
    <v-sheet class="pa-3 bg-grey-lighten-3">
      <v-row>
        <v-col cols="4">
            <v-date-input hide-details variant="outlined" density="compact" prepend-icon="" prepend-inner-icon="$calendar" v-model="meta.search.dtrange" :label="$t('select_range')" multiple="range" :disabled="meta.isloading"/>
        </v-col>
        <v-col>
          <v-btn :text="$t('today')" class="me-2" @click="meta.search.dtrange=[new Date,new Date]" :loading="meta.isloading"/>
          <v-btn :text="$t('yesterday')" class="me-2" @click="meta.search.dtrange=[dayjs().subtract(1,'day').toDate(),new Date]" :loading="meta.isloading"/>
          <v-btn :text="$t('7daysago')" class="me-2" @click="meta.search.dtrange=[dayjs().subtract(7,'day').toDate(),new Date]" :loading="meta.isloading"/>
          <v-btn :text="$t('30daysago')" @click="meta.search.dtrange=[dayjs().subtract(30,'day').toDate(),new Date]" :loading="meta.isloading"/>
        </v-col>
        <v-col cols="2" class="d-flex justify-end">
          <v-btn prepend-icon="mdi-magnify" color="secondary" :text="$t('search')" :loading="meta.isloading" @click="search"/>
        </v-col>
      </v-row>
      <v-row v-if="!meta.fixmem">
        <v-col cols="3">
          <v-select hide-details variant="outlined" density="compact" :items="meta.searchtypes" v-model="meta.search.type" :item-title="item=>$t(item.tkey)" item-value="val" :disabled="meta.isloading"/>
        </v-col>
        <v-col>
          <v-text-field hide-details variant="outlined" density="compact" :placeholder="$t('enteryoursearchterm')" :disabled="meta.isloading" v-model="meta.search.val"/>
        </v-col>
      </v-row>
    </v-sheet>
    <v-card-text>
      <v-table ref="tbl" v-if="meta.struct" fixed-header :height="meta.tblheight">
        <thead>
          <tr>
            <th class="text-left cursor-pointer" v-for="col in meta.cols" @click="sort(col.nm)">
              {{ $t(col.tkey) }}<v-icon v-if="meta.data&&col.nm==meta.sortcol" :icon="meta.isasc?'mdi-arrow-up':'mdi-arrow-down'"/>
            </th>
            <th class="text-center">{{ $t('viewdetails') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-if="!meta.data||meta.data.rows.length==0">
            <td :colspan="meta.cols.length+1" class="text-center">{{ $t('noresultsfound')+' '+$t('pleaseconfirmyoursearchterm') }}</td>
          </tr>
          <tr v-else v-for="row in meta.data.rows">
            <template v-for="col in meta.cols">
              <td v-if="col.type.toLowerCase().includes('date')">{{ formatDayMin(row[col.nm]) }}</td>
              <td v-else>{{ row[col.nm] }}</td>
            </template>
            <td class="text-center"><v-btn :text="$t('viewdetails')" @click="meta.sellog=row"/></td>
          </tr>
        </tbody>
      </v-table>
    </v-card-text>
    <v-card-actions>
      <v-pagination class="ma-auto" v-if="meta.data&&meta.data.rows.length>0" :length="meta.data.totalPages" :total-visible="meta.data.pageCount" v-model="meta.page" @update:model-value="search"/>
    </v-card-actions>
    <v-overlay :model-value="meta.sellog!=null" class="align-center justify-center" contained @click:outside="meta.sellog=null">
      <v-card min-width="400" elevation="5">
        <v-card-title>
          <v-row>
            <v-col>{{ $t('viewlogdetail') }}</v-col>
            <v-spacer/>
            <v-col class="text-end">
              <v-btn density="compact" icon="mdi-close" @click="meta.sellog=null"/>
            </v-col>
          </v-row>
        </v-card-title>
        <v-divider/>
        <v-card-text class="mt-2">
          <v-table>
            <tr v-for="key in _.keys(meta.sellog).filter(key=>!['id','etc','pval','nval'].includes(key))">
              <td>{{ $t(meta.struct[key].tkey) }}</td>
              <td>{{ key=='cdt'||key=='mdt'?formatDay(meta.sellog[key]):meta.sellog[key] }}</td>
            </tr>
          </v-table>
        </v-card-text>
      </v-card>
    </v-overlay>
  </v-card>
  <Teleport v-if="meta.poptype" to="#popbody">
    <v-card>
      <v-card-title>{{ $t('set_log_lim') }}</v-card-title>
      <v-divider/>
      <v-card-text class="pa-5">
        <div>{{ $t('set_log_lim_guide') }}</div>
        <v-select hide-details variant="outlined" density="compact" class="mt-3" :items="meta.loglims" item-title="lbl" item-value="val" v-model="meta.sellim"/>
      </v-card-text>
      <v-divider/>
      <v-card-actions>
        <v-row>
          <v-col class="text-end">
            <v-btn variant="elevated" :text="$t('cancel')" class="me-3" @click="metaStore.pop({ison:false})"/>
            <v-btn variant="elevated" color="primary" :text="$t('confirm')" @click="logLim"/>
          </v-col>
        </v-row>
      </v-card-actions>
    </v-card>
  </Teleport>
</template>
<style>
.admlog .v-input__control{background-color: rgba(255,255,255,1);}
</style>
